import { render, staticRenderFns } from "./Flatfinder.vue?vue&type=template&id=71780e88&"
import script from "./Flatfinder.vue?vue&type=script&lang=js&"
export * from "./Flatfinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports